var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32 3.17578H2C0.895 3.17578 0 4.12478 0 5.29378V15.8818C0 17.0518 0.895 17.9998 2 17.9998H13C14.105 17.9998 15 17.0518 15 15.8818V8.13178L11.086 12.2758C10.7442 12.6413 10.2991 12.8938 9.81 12.9998L7.129 13.5678C5.379 13.9378 3.837 12.3048 4.187 10.4528L4.723 7.61378C4.82 7.10178 5.058 6.63078 5.407 6.26178L8.32 3.17578Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8462 1.31704C16.7451 1.06107 16.5969 0.826345 16.4092 0.625042C16.2247 0.428171 16.0022 0.270677 15.7552 0.162042C15.5118 0.0551784 15.249 0 14.9832 0C14.7174 0 14.4545 0.0551784 14.2112 0.162042C13.9642 0.270677 13.7417 0.428171 13.5572 0.625042L13.0112 1.20304L15.8632 4.22304L16.4092 3.64404C16.5988 3.44427 16.7473 3.20914 16.8462 2.95204C17.0522 2.42651 17.0522 1.84257 16.8462 1.31704ZM14.4502 5.72004L11.5972 2.69904L6.82019 7.75904C6.74971 7.83414 6.70217 7.92782 6.68319 8.02904L6.14719 10.869C6.07719 11.239 6.38619 11.565 6.73519 11.491L9.41719 10.924C9.51477 10.9023 9.6036 10.8518 9.67219 10.779L14.4502 5.72004Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.f038530e76cabfd9f6544e24ebc18f05.svg";
export { ForwardRef as ReactComponent };